module.exports = __webpack_public_path__ + "static/img/mobile-banner.ff092775.png";